var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceHolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 59.5C12.6083 59.5 11.2748 58.9456 10.166 57.8368C9.05722 56.7281 8.50189 55.3936 8.5 53.8333V14.1667C8.5 12.6083 9.05533 11.2748 10.166 10.166C11.2767 9.05722 12.6102 8.50189 14.1667 8.5H53.8333C55.3917 8.5 56.7262 9.05533 57.8368 10.166C58.9475 11.2767 59.5019 12.6102 59.5 14.1667V53.8333C59.5 55.3917 58.9456 56.7262 57.8368 57.8368C56.7281 58.9475 55.3936 59.5019 53.8333 59.5H14.1667ZM17 48.1667H51L40.375 34L31.875 45.3333L25.5 36.8333L17 48.1667Z",
    fill: "#419485"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceHolder);
export default __webpack_public_path__ + "static/media/PlaceHolder.2c1a48bdfd99477179bc049df03ace55.svg";
export { ForwardRef as ReactComponent };